<p-confirmDialog icon="pi pi-exclamation-triangle" acceptLabel="Si" rejectLabel="No"></p-confirmDialog>
<section>
	<div *ngIf="actividad" class="grid col-12 ">

		<div class="col-12 bg-blue-brand border-round-xl align-items-center inline-flex mb-1 ">
			<div class="border-round-3xl bg-white mx-4">
				<i class="pi pi-check text-custom-blue font-bold text-lg m-1"></i>
			</div>
			<p class="text-xl font-bold text-white">{{ actividad.actividadCodificacion }}</p>
		</div>
		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.dependencia}}:</b>
			</div>
			<div>
				<p>{{actividad.dependenciasDescripcion}}</p>
			</div>
		</div>
		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.ciudadano}}:</b>
			</div>
			<div>
				<p>{{actividad.tramitanteCorreo}}</p>
			</div>
		</div>

		<div class="col-12">
			<div>
				<b>{{trans.radicado}} #</b>
			</div>
			<div>
				<p>{{actividad.radicado}}</p>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.orden}}:</b>
			</div>
			<div>
				<p>{{actividad.actividadOrden}}</p>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.fechaInicioPlanificada}}:</b>
			</div>
			<div>
				<p>{{actividad.fechaPlanificadaInicio | date:defaultDateFormat}}</p>
			</div>
		</div>
		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.fechaCierrePlanificada}}:</b>
			</div>
			<div>
				<p>{{actividad.fechaPlanificadaCierre | date:defaultDateFormat}}</p>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.fechaInicioReal}}:</b>
			</div>
			<div>
				<p>{{actividad.fechaRealInicio | date:defaultDateFormat}}</p>
			</div>
		</div>
		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.fechaFinalizacionReal}}:</b>
			</div>
			<div>
				<p>{{actividad.fechaRealCierre | date:defaultDateFormat}}</p>
			</div>
		</div>

		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.estadoDeLaActividad}}:</b>
			</div>
			<div>
				<p>{{actividad.tramEstadosActividadDescripcion}}</p>
			</div>
		</div>
		<div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.usuarioAsignado}}:</b>
			</div>
			<div>
				<p-dropdown [options]="usuariosValidos" appendTo="body" placeholder="Usuario..."
					[(ngModel)]="selectedUsuarioIdValido" optionLabel="correo" optionValue="id"
					(onChange)="onUsuarioValidoChange($event)"
					[disabled]="!ls.hasRole(role.ADMIN_TRAM) || actividad.tramEstadosActividadDescripcion !== 'PENDIENTE'">
				</p-dropdown>
			</div>
		</div>

		<div class="col-12">
			<button pButton type="button" label="Ver Formulario" class="p-button-info p-button-outlined w-full"
				icon="pi pi-book" (click)="openRespuesta(actividad.tramRegistroId)"
				[disabled]="!ls.hasRole(role.GESTION_TRAMITE)" [pTooltip]="trans.requiereRolSeguridad"
				[tooltipDisabled]="ls.hasRole(role.GESTION_TRAMITE)" tooltipPosition="top"></button>
		</div>

	</div>

	<app-actividad-formulario class="w-full" [onSubmitForm]="onSubmitForm" [options]="options"></app-actividad-formulario>

	<div *ngIf="actividad" class="grid col-12 ">
		<div class="col-12 md:col-6 lg:col-4" *ngIf="actividad.tramEstadosActividadDescripcion === 'PENDIENTE' ">
			<button pButton type="button" [label]="trans.finalizarActividad" class="p-button-success p-button-outlined w-full"
				icon="pi pi-fast-forward" (click)="finalizarActividad($event)"
				[disabled]="!ls.hasRole(role.GESTION_TRAMITE) || actividad.usuarioAsignadoCorreo !== ls.getUser.username"></button>
		</div>

		<div class="col-12 md:col-6 lg:col-4">
			<button pButton type="submit" [label]="trans.guardarSeguimiento" icon="pi pi-save"
				class="p-button-outlined w-full" [disabled]="actividad.usuarioAsignadoCorreo !== ls.getUser.username"
				(click)="onSubmitSeguimiento($event)"></button>
		</div>

		<div class="col-12 md:col-6 lg:col-4" *ngIf="actividad.tramEstadosActividadDescripcion === 'FINALIZADO' 
				&& !(actividad.tramEstado === 'FINALIZADO' || actividad.tramEstado === 'RECHAZADO')">
			<button pButton type="button" [label]="trans.reabrirActividad" class="p-button-help p-button-outlined w-full"
				icon="pi pi-lock-open" (click)="reabrirActividadConfirm($event)"
				[disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
		</div>
		<div class="col-12 md:col-6 lg:col-4" *ngIf="actividad.tramEstadosActividadDescripcion === 'PENDIENTE' ">
			<button pButton type="button" [label]="trans.rechazarTramite" class="p-button-danger p-button-outlined w-full"
				icon="pi pi-thumbs-down" (click)="openRechazarModal()" [disabled]="!ls.hasRole(role.ADMIN_TRAM)"></button>
		</div>
	</div>
</section>


<section>
	<form [formGroup]="rechazarForm" (ngSubmit)="onSubmitRechazarForm()">
		<p-dialog header="Rechazar Actividad" [(visible)]="displayRechazarModal" [modal]="true"
			[breakpoints]="{'960px': '100vw'}" [style]="{width: '85vw'}" [draggable]="false" [resizable]="true"
			[maximizable]="true">
			<div class="grid">
				<div class="field col-12 flex flex-column">
					<label for="observaciones">{{trans.observaciones}}<span style="color: red">*</span></label>
					<textarea rows="5" cols="60" pInputTextarea formControlName="observaciones"></textarea>
					<ng-container
						*ngIf="rechazarForm.get('observaciones')?.invalid && rechazarForm.get('observaciones')?.touched">
						<app-form-group-error-message [control]="rechazarForm.get('observaciones')"></app-form-group-error-message>
					</ng-container>
				</div>
			</div>
			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right"
							icon="pi pi-eraser" (click)="resetRechazarForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right"
							[disabled]="!ls.hasRole(role.ADMIN_TRAM)" [pTooltip]="trans.requiereRolSeguridad"
							[tooltipDisabled]="ls.hasRole(role.ADMIN_TRAM)" tooltipPosition="top"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>